import React from 'react';
import styled from 'styled-components';
import Slide from 'react-reveal/Slide';
import { Item } from '../styles/styles.js';

import { menuData } from '../data/menuData';

const TitleSeparator = styled.h2`
  margin-top: 30px;
  margin-left: 30px;
  color: #00a85a;
`;

// Definição dos tamanhos para facilitar o map de preços
const sizeLabels = ['P', 'M', 'G', 'F'];
const sizeColors = [
  'bgcolor-size1',
  'bgcolor-size2',
  'bgcolor-size1',
  'bgcolor-size3',
];

const Pizzas = () => {
  return (
    <>
      {menuData.map(categoryGroup => (
        <React.Fragment key={categoryGroup.category}>
          {/* Título da Categoria com animação */}
          <Slide left cascade duration={300}>
            <TitleSeparator>{categoryGroup.category}</TitleSeparator>
          </Slide>

          {categoryGroup.items.map((pizza, index) => (
            <Item key={pizza.id} firstItem={index === 0}>
              <div className="item-separator">
                <h4 className="item-title">
                  {pizza.promo && <span className="badge">Promoção</span>}
                  {pizza.id} - {pizza.name}
                </h4>
                <p className="item-desc">{pizza.desc}</p>
              </div>

              <div className="item-price-container">
                {pizza.prices.map((price, i) => (
                  <div className="item-price-wrapper" key={i}>
                    <div className={`item-price-size ${sizeColors[i]}`}>
                      <p>{sizeLabels[i]}</p>
                    </div>
                    <div className="item-price">
                      <p>{price}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Item>
          ))}
        </React.Fragment>
      ))}
    </>
  );
};

export default Pizzas;
